import { LUXON_FORMAT_DAY_MONTH_YEAR, ZONE_UTC } from '@/utils/luxon';
import { DateTime } from 'luxon';
import type { PatientVerifyIhiResponseData } from './hooks/usePatientIhi';

export const getIHINumberFromUrl = (ihiNumberUrl?: string | null) => {
  return ihiNumberUrl ? ihiNumberUrl.split('/').pop() : null;
};

export const formatPatientDobIhiModals = (patientDobISO?: string | null) => {
  return patientDobISO ? DateTime.fromISO(patientDobISO, { zone: ZONE_UTC }).toFormat(LUXON_FORMAT_DAY_MONTH_YEAR) : '';
};

const compareValuePMSVersusIHI = (
  patientsCurrentValue?: string | number | null,
  patientsIHIValue?: string | number | null
) => {
  if (!patientsIHIValue) {
    return false;
  }
  return patientsCurrentValue !== patientsIHIValue;
};
export type IHIPatientFields = {
  FirstName?: string | null;
  LastName?: string | null;
  gender?: string | null;
  DoB?: string | null;
  medicareNumber: string | null;
  medicare_ref_number: number | null;
  ihi_number: string | null;
};

export type PmsIhiComparisonResult = {
  firstName: boolean;
  lastName: boolean;
  medicareNumber: boolean;
  medicareRefNumber: boolean;
  ihiNumber: boolean;
  dob: boolean;
  gender: boolean;
};

export const compareValuesPMSVersusIHI = ({
  patientInPMS,
  patientInIHI
}: {
  patientInPMS: IHIPatientFields;
  patientInIHI: PatientVerifyIhiResponseData;
}): PmsIhiComparisonResult => {
  const { patient: ihiPatient } = patientInIHI;

  return {
    firstName: compareValuePMSVersusIHI(patientInPMS?.FirstName?.toLowerCase(), ihiPatient?.firstName?.toLowerCase()),
    lastName: compareValuePMSVersusIHI(patientInPMS?.LastName?.toLowerCase(), ihiPatient?.lastName?.toLowerCase()),
    medicareNumber: compareValuePMSVersusIHI(patientInPMS?.medicareNumber, ihiPatient?.medicareNumber),
    medicareRefNumber: compareValuePMSVersusIHI(
      patientInPMS?.medicare_ref_number,
      ihiPatient?.medicareRefNumber ? parseInt(ihiPatient?.medicareRefNumber) : null
    ),
    ihiNumber: compareValuePMSVersusIHI(patientInPMS?.ihi_number, getIHINumberFromUrl(ihiPatient?.ihiNumber) as string),
    dob: compareValuePMSVersusIHI(
      formatPatientDobIhiModals(patientInPMS?.DoB),
      formatPatientDobIhiModals(ihiPatient?.doB)
    ),
    gender: compareValuePMSVersusIHI(patientInPMS.gender?.toLowerCase() ?? null, ihiPatient?.sex?.toLowerCase() ?? null)
  };
};

export enum IhiStatus {
  VERIFIED,
  UNVERIFIED,
  NEW_PATIENT
}

export const getIhiStatus = (ihiNumber?: string | null, numberStatus?: string | null, recordStatus?: string | null) => {
  if (!ihiNumber) {
    return IhiStatus.NEW_PATIENT;
  }

  if (numberStatus?.toLowerCase() !== 'active' || recordStatus?.toLowerCase() !== 'verified') {
    return IhiStatus.UNVERIFIED;
  }

  return IhiStatus.VERIFIED;
};
